<template>
  <!-- 商品列表 -->
  <div class="productList">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['商品管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-link
          @click="explain = true"
          style="margin-right: 10px"
          icon="el-icon-question"
          :underline="false"
          type="warning"
          >操作说明</el-link
        >

        <!-- <el-button
          type="primary"
          icon="el-icon-folder-opened"
          @click="chooseImgDialog = true"
          >批量上传详情图</el-button
        > -->
        <el-dropdown style="margin-right: 10px" @command="dropdownCommand">
          <el-button type="primary">
            批量上传详情图<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="0">按条形码上传</el-dropdown-item>
            <el-dropdown-item :command="1">按ERP商品内码上传</el-dropdown-item>
            <el-dropdown-item :command="2">按ERP商品编号上传</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- <el-button type="primary" icon="el-icon-download" @click="exportData"
          >导出数据</el-button
        > -->
        <!-- <upload text="商品分类" @fileChange="goodsClass" style="margin-right: 10px"></upload> -->
        <!-- <el-button
          type="danger"
          icon="el-icon-download"
          :disabled="selectedList.length == 0"
          @click="handlePut(1)"
          >批量下架
        </el-button>
        <el-button
          type="primary"
          icon="el-icon-upload2"
          :disabled="selectedList.length == 0"
          @click="handlePut(2)"
          >批量上架
        </el-button> -->
        <!-- 价格等级现在没有使用 -->
        <!-- <el-button type="primary" icon="el-icon-s-open" @click="priceLevel"
          >价格等级</el-button
        > -->
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <!-- 洛奥活动状态字段修改为库存预警 -->
        <label class="label">库存预警：</label>
        <el-select
          v-model="searchForm.activityStatus"
          placeholder="库存预警"
          style="width: 100px; margin-right: 10px"
          clearable
        >
          <el-option label="全部" value="false"></el-option>
          <el-option label="是" value="Y"></el-option>
          <el-option label="否" value="N"></el-option>
        </el-select>
        <!-- <el-checkbox
          style="margin-right: 5px"
          v-model="searchForm.activityStatus"
          >库存预警</el-checkbox
        > -->
        <label class="label">分类：</label>
        <el-select
          v-model="searchForm.classify"
          placeholder="商品分类"
          style="width: 100px; margin-right: 10px"
          clearable
        >
          <el-option label="全部分类" value="0"></el-option>
          <el-option
            v-for="(item, index) in classifyList"
            :key="index"
            :label="item.label"
            :value="item.value"
            style="white-space: pre"
          >
          </el-option>
        </el-select>
        <label class="label">楼层：</label>
        <el-select
          v-model="searchForm.attr"
          placeholder="商品楼层"
          style="width: 100px; margin-right: 10px"
          clearable
        >
          <el-option label="全部" value="0"></el-option>
          <el-option
            v-for="(item, index) in attrList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <label class="label">商品状态：</label>
        <el-select
          v-model="searchForm.status"
          placeholder="商品状态"
          style="width: 100px; margin-right: 10px"
          clearable
        >
          <el-option label="全部" value="9"></el-option>
          <el-option label="已启用" value="2"></el-option>
          <el-option label="未启用" value="1"></el-option>
        </el-select>
        <label class="label">库存状态：</label>
        <el-select
          v-model="searchForm.stock"
          placeholder="库存状态"
          style="width: 100px; margin-right: 10px"
          clearable
        >
          <el-option label="全部" value="99"></el-option>
          <el-option label="有库存" value="1"></el-option>
          <el-option label="无库存" value="0"></el-option>
        </el-select>
        <label class="label">商品图片：</label>
        <el-select
          v-model="searchForm.pic"
          placeholder="商品图片"
          style="width: 100px; margin-right: 10px"
          clearable
        >
          <el-option label="全部" value="99"></el-option>
          <el-option label="有图片" value="Y"></el-option>
          <el-option label="无图片" value="N"></el-option>
        </el-select>
        <!-- <el-select
          v-model="searchForm.activityArea"
          placeholder="活动专区"
          style="width: 100px; margin-right: 5px"
          clearable
        >
          <el-option label="全部" value="99"></el-option>
          <el-option label="折扣专区" value="DZK"></el-option>
          <el-option label="满赠专区" value="DMZ"></el-option>
          <el-option label="换购专区" value="DHG"></el-option>
          <el-option label="抢购专区" value="DQG"></el-option>
          <el-option label="组合专区" value="GZH"></el-option>
        </el-select> -->
        <p>
          <span class="labeljs">检索：</span>
          <el-input
            v-model="searchForm.name"
            style="width: 150px; margin-right: 10px"
            clearable
            placeholder="输入编号/名称"
          >
          </el-input>
        </p>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column
        align="center"
        width="150"
        prop="code"
        show-overflow-tooltip
        label="商品编号(ERP)"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        align="center"
        width="160"
        show-overflow-tooltip
        label="商品名称"
      >
      </el-table-column>
      <!-- 王航说不要了，没什么用 -->
      <!-- <el-table-column prop="entname" align="center" show-overflow-tooltip label="机构名称">
      </el-table-column> -->
      <el-table-column
        prop="goods_no"
        align="center"
        width="160"
        show-overflow-tooltip
        label="ERP内码"
      >
      </el-table-column>
      <el-table-column
        prop="specification"
        label="商品规格"
        width="120"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="packingNnit"
        label="包装单位"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="producer"
        label="生产厂家"
        width="120"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="classify"
        label="商品分类"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="repertory"
        label="库存"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="retailPrice"
        width="150"
        label="建议零售价"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="validTime"
        label="效期时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="id"
        show-overflow-tooltip
        label="商品ID"
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag :type="scope.row.status | formatType">{{
            scope.row.status | formatStatus
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="100" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="handleAdd(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="success"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, 2)"
            v-if="scope.row.status == 1"
            >启用</el-button
          >
          <el-button
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, 1)"
            v-else
            >禁用
          </el-button>
          <!-- <el-button type="primary" style="padding:2px 3px;" plain
            @click="controlGoods(scope.row)">控销</el-button> -->
          <!-- <el-button type="primary" style="padding:2px 3px;" plain
            @click="areaPrice(scope.row)">区域价格</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>

    <upload
      ref="upload"
      style="dispay: none"
      @fileChange="uploadGoods"
      accept="image/jpg,image/jpeg,image/png"
      :multiple="true"
    ></upload>

    <el-dialog
      title="操作说明"
      :visible.sync="explain"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="70%"
    >
      <div class="explain-text">
        <p>该界面显示的为从ERP同步过来的基础商品数据</p>
        <p>
          编辑：可调整商品封面图、详情图、说明书、绑定商品分类、商品标签等信息（灰色输入框代表不可编辑）
        </p>
        <p>禁用：禁用后商品将不会在商城中显示</p>
        <!-- <p>价格等级：可设置多个价格等级，添加价格等级后，需要在商品编辑界面中设置价格，<span style="font-weight:bold;">客户列表</span>界面绑定后生效</p> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
//混入
import { formatStatus } from "@/mixins/filters/formatStatus.js";

export default {
  name: "productImgList",
  mixins: [formatStatus],
  data() {
    return {
      entId: "",
      /**表格数据 */
      // {
      //   id:"商品id",
      //   code:"商品编号",
      //   name:"商品名称",
      //   entid:"机构ID",
      //   entname:"机构名称",
      //   specification:"商品规格",
      //   packingNnit:"包装单位",
      //   producer:"生产厂家",
      //   classify:"商品分类",
      //   repertory:"库存",
      //   retailPrice:"建议零售价",
      //   validTime:"效期时间",
      //   status:"状态",
      //   sort:"排序"
      // }
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**搜索表单 */
      // 商品分类 商品属性 商品状态 库存状态 商品图片 活动专区 活动状态 商品名称
      searchForm: {
        classify: "",
        attr: "",
        status: "2",
        stock: "",
        pic: "",
        activityArea: "",
        activityStatus: "",
        name: "",
      },
      /**select选中项 */
      selectedList: [],
      /**搜索下拉数据 */
      attrList: [], //商品属性列表
      classifyList: [], //商品分类别表

      /**上传详情图 */
      imgType: 1, //上传图片的类型

      /**使用说明 */
      explain: false,
    };
  },
  mounted() {
    this.entId = localStorage.getItem("entId");
    this.getTableData();
    this.getClassifyList();
  },
  methods: {
    /**批量上传图片 */
    /**dropdownCommand回调，记录上传图片的类型 */
    dropdownCommand(val) {
      this.imgType = val;
      this.$confirm("最多可选择200张", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$refs.upload.handleClick();
      });
    },

    // 商品详情图片上传回调
    uploadGoods(file) {
      file = file.slice(0, 200); //最多可选择200张，多余的将会截断
      if (file.length) {
        let type = ["TM", "SP", "SPCode"];
        let fileData = new FormData();
        for (let i = 0; i < file.length; i++) {
          fileData.append("FileNmaes", file[i]);
        }
        this.$uploadRequest({
          url:
            "Management/GoodsAdmin/SaveGoodsImgToList?entId=" +
            this.entId +
            "&drType=" +
            type[this.imgType],
          method: "post",
          data: fileData,
        })
          .then((res) => {
            console.log(res);
            if (res.flag == 0) {
              this.$confirm(res.message + "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {});
              // this.$message({
              //   message: res.message,
              //   type: 'success'
              // })
            } else {
              this.$confirm(res.message + "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {});
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      }
    },

    updata() {
      this.getTableData();
      this.getClassifyList();
    },
    /**获取表格 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "GoodsList",
        category: this.searchForm.classify || "0",
        attribute: this.searchForm.attr || "0",
        status: this.searchForm.status || "9",
        strWhere: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
        promtype:
          this.searchForm.activityArea == "99"
            ? ""
            : this.searchForm.activityArea,
        // promstatus: this.searchForm.activityStatus || "99",
        promstatus: this.searchForm.activityStatus ? "Y" : "",
        goodsPic: this.searchForm.pic || "99",
        spStatus: this.searchForm.stock || "99",
      };
      let proc = "Proc_Admin_GoodsList"; // 存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url:
          "goods/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          this.allPage = res.recordCount;
          this.tableData = [];
          if (res.flag == 0) {
            for (let i = 0; i < res.data.length; i++) {
              this.tableData.push({
                id: res.data[i].article_id,
                code: res.data[i].goodscode,
                name: res.data[i].sub_title,
                entname: res.data[i].entname,
                entid: res.data[i].entId,
                specification: res.data[i].drug_spec,
                packingNnit: res.data[i].package_unit,
                producer: res.data[i].drug_factory,
                classify: res.data[i].category,
                repertory: res.data[i].stock_quantity,
                retailPrice: res.data[i].price,
                validTime: res.data[i].valdate,
                articleId: res.data[i].article_id,
                organId: res.data[i].adminentid,
                status: res.data[i].status,
                sort: res.data[i].sort_id,
                goods_no: res.data[i].goods_no,
              });
            }
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },

    /**获取检索条件数据 */
    //获取分类和属性
    getClassifyList() {
      let data = {
        type: "GoodsAttributeBox",
      };
      let proc = "Proc_Admin_GoodsList"; // 存储过程名
      let type = "LoadCheckBox";
      this.$requestSys({
        url:
          "goods/ashx/returnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          if (res.flag == 0) {
            this.attrList = this.changeArr(res.attributeList);
            this.classifyList = this.changeArr(res.categoryList);
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    //数组转化
    changeArr(list) {
      list = list.split("</option><option");
      list = list.map((item) => {
        let label = item
          .split("'>")[1]
          .split("</option>")[0]
          .replace(/&nbsp;/g, " ");
        let value = item.split("value='")[1].split("'>")[0];
        return { label, value };
      });
      return list;
    },

    /**selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    /**批量上架 */
    handlePut(status) {
      //将selected选中的list转化为字符串
      let idList = [];
      this.selectedList.forEach((ele) => {
        idList.push(ele.id);
      });
      idList = idList.join();
      this.changeStatus({ id: idList }, status);
    },
    priceLevel() {
      this.$router.push("priceLevel");
    },
    // 上传商品分类
    goodsClass(file) {
      if (file && file.length) {
        let fileData = new FormData();
        for (let i = 0; i < file.length; i++) {
          fileData.append("fulFile", file[i]);
        }
        let judge = "";
        let type = "UploadClassificationExecl";
        this.$uploadRequest({
          url: "admin/ashx/UploadExcel.ashx?type=" + type + "&judge=" + judge,
          method: "post",
          data: fileData,
        })
          .then((res) => {
            if (res.flag == 0) {
              this.$message({
                message: "上传成功",
                type: "success",
              });
              this.getTableData();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      }
    },
    /**点击新增/编辑 */
    handleAdd(row) {
      let prams = null;
      if (row) {
        prams = encodeURIComponent(JSON.stringify({ goodsId: row.articleId }));
      } else {
        prams = row;
      }
      this.$router.push({
        path: "addImgProduct",
        query: {
          prams: prams,
        },
      });
      prams = null;
    },
    /**清空表单信息 */
    clearForm() {
      this.$refs["goodForm"].resetFields();
      for (const key in this.goodForm) {
        this.goodForm[key] = null;
      }
      this.addDialog = false;
    },
    /**提交新增分类 */
    submit() {
      this.$refs["goodForm"].validate((valid) => {
        if (valid) {
          this.$message({
            message: "执行提交",
            type: "info",
          });
        }
      });
    },
    changeStatus(row, status) {
      let msg = "确定要执行操作吗?";
      let type = "info";
      if (status == 1) {
        msg = "确定下架吗?";
        type = "warning";
      } else if (status == 2) {
        msg = "确定上架吗?";
        type = "success";
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type,
      })
        .then(() => {
          let data = {
            type: "AuditGoods",
            article_id: row.id,
            status: status,
          };
          let proc = "Proc_Admin_GoodsList"; // 存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            url:
              "goods/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            method: "post",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
    // 控销
    controlGoods(row) {
      let prams =
        row && encodeURIComponent(JSON.stringify({ goodsId: row.articleId }));
      this.$router.push({
        path: "addConGoods",
        query: {
          prams: prams,
        },
      });
    },
    // 区域价格
    areaPrice(row) {
      let prams =
        row &&
        encodeURIComponent(
          JSON.stringify({ goodsId: row.articleId, entId: row.entid })
        );
      this.$router.push({
        path: "productAreaPrice",
        query: {
          prams: prams,
        },
      });
    },
    // 导出数据
    exportData() {
      let data = {
        type: "GoodsList",
        userId: window.localStorage.getItem("userId"),
        entId: window.localStorage.getItem("entId"),
        category: this.searchForm.classify || "0",
        attribute: this.searchForm.attr || "0",
        status: this.searchForm.status || "9",
        strWhere: this.searchForm.name,
        promtype:
          this.searchForm.activityArea == "99"
            ? ""
            : this.searchForm.activityArea,
        // promstatus: this.searchForm.activityStatus || "99",
        promstatus: this.searchForm.activityStatus ? "Y" : "",
        goodsPic: this.searchForm.pic || "99",
        spStatus: this.searchForm.stock || "99",
        PageIndex: 1,
        PageSize: 9999999,
      };
      let proc = "Proc_Admin_GoodsList";
      window.location.href =
        this.baseUrl +
        "Order/NoPIGExprot?json=" +
        encodeURIComponent(JSON.stringify(data)) +
        "&proc=" +
        encodeURIComponent(proc) +
        "&name=商品列表";
    },
  },
};
</script>

<style scoped>
.productList {
  width: 100%;
  height: 100%;
}

/**选择上传图片类型 */
.imgType {
  padding: 20px 0 30px;
}

.imgType-item {
  width: 200px;
  height: 100px;
  margin: 20px auto 0;
  /* background-color: #409EFF; */
}

.imgType-item:first-of-type {
  margin-top: 0;
}

.imgType-item-btn {
  width: 100%;
  height: 100%;
}
.label {
  font-size: 13px;
}
.labeljs {
  font-size: 13px;
  margin-left: 10px;
}
</style>